import styled from 'styled-components';

const StyledOppHeader = styled.div<{ bigAvatar?: boolean }>`
  position: sticky;
  top: 0;
  z-index: 1;
  .contact-info-container {
    color: #858585;
    h2,
    h3 {
      font-weight: normal !important;
      line-height: 1.5rem;
    }
    h2 
      color: #4B4B4B;
    }
  }
  .navButton {
    display: flex;
    height: 100px;
    width: 70px !important;
    align-items: center;
    justify-content: center;
  }
  .ant-card-bordered {
    border-bottom: 1px solid #9A9A9A !important;
    border-radius: 0;
  }
  .ant-card-body {
    padding: 0 1.5rem;
  }

  .card-container {
    width: 100%;
    gap: 12;
    padding: 0 8px;
    .flex-col-container {
      flex-direction: row;
      justify-content: space-between;
      .avatar-Opp-container {
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding: 8px 0;
        gap: 8px;
        .avatar-container {
          height: 32px;
          width: 32px;
          background-color: #0078d4;
          font-size: ${(props) => (props.bigAvatar ? '28px !important' : 'undefined')};
        }
        .industries-tags {
          display: flex;
          gap: 8px;
        }
      }
    }
    .inputs-buttons-container {
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      gap: 15px;
      width: 75%;
      .input-style {
        padding: 8px 12px;
      }
    }
  }
`;

export default StyledOppHeader;
